import { WeaTools } from 'ecCom';
import { message } from 'antd';
import _loadjs from 'loadjs';
const devModuleCustomFiles = [
    `css!/cloudstore/config/devStatic/devModuleStyle.css?v=${Date.now()}`,
    `/cloudstore/config/devStatic/devModuleCustom.js?v=${Date.now()}`,
  ];
/**
 * 执行事件回调
 *
 * @param {*} callback
 */
const doEventCallback = (callback) => {
  if (callback && typeof callback == 'function') {
    callback();
  }
};

/**
 * 执行事件回调
 *
 * @param {*} eventName
 * @param {*} callback
 */
const doEventSuccess = (eventName, callback) => {
  const _eventRegister = window.eventRegister;
  if (_eventRegister && _eventRegister.startList && typeof _eventRegister.startList == 'function') {
    try {
      _eventRegister.startList(
        eventName,
        () => doEventCallback(callback),
        () => doEventCallback(callback)
      );
    } catch (e) {
      message.error(e.message);
      doEventCallback(callback);
    }
  } else {
    doEventCallback(callback);
  }
};

export const doEvent = (eventName, callback) => {
  const loadjs = window.loadjs || _loadjs;

  loadjs.isDefined('devModuleCustom')
    ? loadjs.ready('devModuleCustom', {
        success: () => doEventSuccess(eventName, callback),
        error: () => doEventSuccess(eventName, callback),
      })
    : loadjs(devModuleCustomFiles, 'devModuleCustom', {
        async: true,
        success: () => doEventSuccess(eventName, callback),
        error: () => doEventSuccess(eventName, callback),
      });
};

/**
 * 获取本地Cookie数据
 *
 */
export const getCookieValue = (name) => {
    let value = '';

    const cookie = document.cookie;
    const list = cookie.split('; ');
    for (let i = 0, len = list.length; i < len; i++) {
        let arr = list[i].split('=');
        if (arr[0] == name) {
            value = arr[1];
        }
    }

    if (value == 'true') {
        value = true;
    } else if (value == 'false') {
        value = false;
    }

    return value;
};
/**
 * 获取本地缓存数据
 *
 */
export const getLSValue = (key1, key2) => {
    const obj = WeaTools.ls.getJSONObj(key1);
    return obj && obj[key2];
};

/**
 * 设置本地缓存数据
 *
 */
export const setLSValue = (key1, key2, value) => {
    const obj = WeaTools.ls.getJSONObj(key1) || {};
    obj[key2] = value;
    WeaTools.ls.set(key1, obj);
};

/**
 * 初始化本地缓存数据
 *
 */
export const initLSValue = (loginId, langId) => {
    const _loginId = getLSValue('login', 'loginId');
    const _langId = getLSValue('login', 'langId');

    const ls = window.localStorage;
    const keys = [];
    if (!_loginId || !_langId || loginId != _loginId || langId != _langId) {
        keys.push('e9_locale');
        for (let i = 0, len = ls.length; i < len; i++) {
            const key = ls.key(i);
            if (/^theme-/.test(key) || /^portal-/.test(key) || /^edata-/.test(key) || /^tabdata-/.test(key)) {
                keys.push(key);
            }
        }
    }

    for (let i = 0, len = keys.length; i < len; i++) {
        ls.removeItem(keys[i]);
    }

    WeaTools.ls.set('isInitLSValue', true);
};


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/components/wea-login-pop/loginutil.js